<template>
  <div>
    <div class="flex gap-2 text-primary mb-6">
      <v-icon
        color="primary"
        size="20">
        mdi-video-input-hdmi
      </v-icon>
      <span class="text-xl font-medium">{{ $t('accountconnector.header') }}</span>
    </div>

    <snt-loading
      :loading="$apollo.loading"
      min-height="285px">
      <v-card
        class="mb-3"
        flat>
        <v-card-title>
          <div class="text-h2-headline mb-3">
            ตั้งค่าการสร้างเอกสารของระบบบัญชี
          </div>
        </v-card-title>
        <v-card-text>
          <!-- <toggle-form
            v-model="form.createAccountingQuotation"
            :state="state['createAccountingQuotation']"
            text="สร้างใบเสนอราคา (Quotation)"
            @change="submit('createAccountingQuotation')" />
          <div class="my-7">
            <hr />
          </div>
          <toggle-form
            v-model="form.createAccountingTaxInvoice"
            :state="state['createAccountingTaxInvoice']"
            text="สร้างใบแจ้งหนี้ (Invoice) และใบกำกับภาษี (Tax Invoice)"
            @change="submit('createAccountingTaxInvoice')" /> -->
          <toggle-form
            v-model="form.createAccountingReceipt"
            :state="state['createAccountingReceipt']"
            text="สร้างใบเสร็จรับเงิน (Receipt)"
            @change="submit('createAccountingReceipt')" />
          <!-- <toggle-form
            v-model="form.createAccountingCreditNote"
            :state="state['createAccountingCreditNote']"
            text="สร้าง Credit Note เมื่อทำรายการคืนสินค้า"
            @change="submit('createAccountingCreditNote')" />
          -->
        </v-card-text>
      </v-card>
    </snt-loading>
    <v-tabs
      v-model="tab"
      class="app-tab"
      show-arrows>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab
        v-for="(item) in tabs"
        :key="`tab-${item.value}`"
        :href="`#${item.value}`">
        <v-img
          v-if="item.image"
          :src="item.image"
          class="mr-2 rounded"
          height="24"
          width="24"
          contain />
        <span class="text-capitalize">{{ item.text }}</span>
      </v-tab>
      <v-spacer />
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        value="peak"
        transition="none">
        <PeakConnect />
      </v-tab-item>
      <!-- <v-tab-item
        value="flowaccount"
        transition="none">
        <FlowAccountConnect />
      </v-tab-item> -->
    </v-tabs-items>
  </div>
</template>

<script>
import { UPDATE_SETTING, GET_SETTING_ACCOUNTCONNECT } from '@/resources/graphql'
import PeakConnect from '../components/Peak/PeakConnect.vue'
// import FlowAccountConnect from '../components/FlowAccount/FlowAccountConnect.vue'

export default {
  components: {
    PeakConnect
    // FlowAccountConnect
  },
  apollo: {
    setting: {
      query: GET_SETTING_ACCOUNTCONNECT,
      result () {
        this.form = {
          // createAccountingCreditNote: this.setting.createAccountingCreditNote,
          // createAccountingTaxInvoice: this.setting.createAccountingTaxInvoice,
          // createAccountingQuotation: this.setting.createAccountingQuotation,
          createAccountingReceipt: this.setting.createAccountingReceipt
        }
      }
    }
  },
  data () {
    return {
      tabs: [
        // {
        //   text: 'Flow Account',
        //   value: 'flowaccount'
        // },
        {
          text: 'PEAK Account',
          value: 'peak'
        }
      ],
      form: {
        // createAccountingCreditNote: false,
        createAccountingReceipt: false,
        createAccountingTaxInvoice: false,
        createAccountingInvoice: false,
        createAccountingQuotation: false
      },
      state: {
        // createAccountingCreditNote: 'ready',
        createAccountingReceipt: 'ready',
        createAccountingTaxInvoice: 'ready',
        createAccountingInvoice: 'ready',
        createAccountingQuotation: 'ready'
      }
    }
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
  methods: {
    async submit (field) {
      this.dialog = false
      this.state[field] = 'loading'
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            [field]: this.form[field]
          }
        }
      }).catch(() => {
        this.state[field] = 'error'
      })
      if (res) {
        const { data: { updateSetting } } = res
        if (updateSetting.errors && Object.keys(updateSetting.errors).length) {
          this.state[field] = 'error'
        } else {
          this.state[field] = 'success'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
